import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Issue, IssueService} from "../../../../../backend";
import {LocaleService} from "../../../service/locale.service";
import {AbstractLazyComponent} from "../../../shared/component/abstract-lazy/abstract-lazy.component";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-current-edition',
  template: '',
  standalone: true,
  imports: [CommonModule],
})
export class CurrentEditionComponent extends AbstractLazyComponent implements OnInit {

  #destroyRef = inject(DestroyRef);
  issue: Issue | undefined;

  constructor(protected issueService: IssueService, localeService: LocaleService) {
    super(localeService);
  }

  override ngOnInit(): void {
    super.ngOnInit()
    this.loadData();
  }

  override ngOnLanguageChange() {
    super.ngOnLanguageChange();
    this.loadData();
  }

  loadData() {

    this.isLoaded = false;
    this.issueService.findPortalCurrentIssue(this.getPortalId()!, this.getLocale())
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
          next: (value: any) => {
            this.issue = value;
            this.isLoaded = true;
          },
          error: (error: any) => {
            this.isLoaded = true;
            console.log(error);
          }
        }
      );
  }
}
